import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  // For the MukeshAdminPage, we don't need to check authentication
  // as it handles its own authentication
  if (location.pathname === '/mukesh') {
    return <>{children}</>;
  }

  // For other protected routes, we'll implement proper authentication later
  return <>{children}</>;
};

export default ProtectedRoute;
